export * from './isDefined';
export * from './isFunction';
export * from './isPromise';
